import { createAsyncThunk } from '@reduxjs/toolkit';

import { startAutoRefresh } from '@/shared/utils/requestBuilder';
import { onboardingService } from './services';
import {
  CompleteOnboardingPayload,
  CompleteOnboardingResponse,
  CreateDepartmentPayload,
  CreateDepartmentResponse,
  InviteMemberWithSectorsPayload,
  InviteMemberWithSectorsResponse,
  ValidateOnboardingTokenResponse,
} from '../types';

export const validateToken = createAsyncThunk<ValidateOnboardingTokenResponse, { token: string }>(
  'onboarding/validate-token',
  async ({ token }, { rejectWithValue }) => {
    try {
      return await onboardingService.validateToken(token);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const completeOnboarding = createAsyncThunk<
  CompleteOnboardingResponse,
  CompleteOnboardingPayload
>('onboarding/complete', async (payload, { rejectWithValue }) => {
  try {
    const result = await onboardingService.completeOnboarding(payload);
    startAutoRefresh();
    return result;
  } catch (error) {
    return rejectWithValue((error as Error).message);
  }
});

export const createSetor = createAsyncThunk<CreateDepartmentResponse, CreateDepartmentPayload>(
  'onboarding/createSetor',
  async (payload, { rejectWithValue }) => {
    try {
      return await onboardingService.createDepartment(payload);
    } catch (error) {
      return rejectWithValue((error as Error).message);
    }
  },
);

export const inviteMemberWithSectors = createAsyncThunk<
  InviteMemberWithSectorsResponse,
  InviteMemberWithSectorsPayload
>('onboarding/inviteMemberWithSectors', async (payload, { rejectWithValue }) => {
  try {
    return await onboardingService.convidarMembroComSetores(payload);
  } catch (error) {
    return rejectWithValue((error as Error).message);
  }
});
